import { render, staticRenderFns } from "./QuizAudio.vue?vue&type=template&id=46a615e7&scoped=true&"
import script from "./QuizAudio.vue?vue&type=script&lang=ts&"
export * from "./QuizAudio.vue?vue&type=script&lang=ts&"
import style0 from "./QuizAudio.vue?vue&type=style&index=0&id=46a615e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a615e7",
  null
  
)

export default component.exports